import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import brandIcon from '../../assets/brandIcon.png';
import brandIconLight from '../../assets/brandIconLight.png';
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
const Navigation = ({ color }) => {
 const location = useLocation();
 const [url, setUrl] = React.useState('/');
 React.useEffect(() => {
  setUrl(location.pathname + location.hash);
 }, [location]);
 return (
  <NavDiv color={color}>
   <Navbar expand='lg'>
    <Navbar.Brand as={Link} to='/'>
     <BrandImage
      src={window.location.pathname === '/about' ? brandIconLight : brandIcon}
      alt='zigma-icon'
     />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls='basic-navbar-nav' />
    <Navbar.Collapse
     id='basic-navbar-nav'
     className='justify-content-end align-items-center'
    >
     <Nav
      className={
       window.location.pathname === '/about'
        ? 'me-auto navbar-nav-dark'
        : 'me-auto navbar-nav-light'
      }
     >
      <Nav.Link as={Link} to='/' className={url === '/' ? 'active' : null}>
       Home
      </Nav.Link>
      <Nav.Link
       as={Link}
       to='/newEPR'
       className={url === '/newEPR' ? 'active' : null}
      >
       New To EPR
      </Nav.Link>
      <Nav.Link
       as={HashLink}
       to='/#patnersdiv'
       className={url === '/#patnersdiv' ? 'active' : null}
      >
       Partner
      </Nav.Link>
      <Nav.Link
       as={HashLink}
       to='/#aboutdiv'
       className={url === '/#aboutdiv' ? 'active' : null}
      >
       About Zigma
      </Nav.Link>
      <Nav.Link
       as={HashLink}
       to='/#contact'
       className={url === '/#contact' ? 'active' : null}
      >
       Contact Us
      </Nav.Link>
      <Nav.Link href='https://zigma-dashboard.netlify.app/'>
       <ColoredButton>Log In</ColoredButton>
      </Nav.Link>
     </Nav>
    </Navbar.Collapse>
   </Navbar>
  </NavDiv>
 );
};

export default Navigation;
const NavDiv = styled.div`
 width: 80%;
 background-color: transparent;
 padding-top: 3rem;
 margin: 0 auto;
 .navbar {
  background-color: ${(props) => props.color};
 }
`;
const ColoredButton = styled.div`
 font-size: 2rem;
 background: linear-gradient(96.44deg, #7dc614 11.01%, #a4e744 92.75%);
 color: white;
 text-align: center;
 border-radius: 10px;
 padding: 0.25em 2.5em;
 align-self: center;
`;
const BrandImage = styled.img`
 width: 18rem;
 height: auto;
 object-fit: cover;
 @media only screen and (max-width: 768px) {
  width: 18rem;
 }
`;
